export default {
  control: {
    backgroundColor: 'var(--select-background-color)',
    fontSize: 14,
    fontWeight: 'normal',
    padding: '0.47rem 0.75rem',
    borderRadius: '0.25rem',
    border: '1px solid var(--input-border-color)',
  },

  '&multiLine': {
    control: {
      fontFamily: 'monospace',
      minHeight: 63,
    },
    highlighter: {
      padding: 9,
      border: '1px solid transparent',
    },
    input: {
      padding: 9,
      border: '1px solid silver',
    },
  },

  '&singleLine': {
    display: 'inline-block',
    width: '100%',

    highlighter: {
      padding: 1,
      border: '2px inset transparent',
    },
    input: {
      //   fontSize: '0.8125rem',
      padding: '0.47rem 0.75rem',
      border: '2px solid transparent',
      fontWeight: 400,
      lineHeight: 1.5,
      color: 'var(--select-text-color)',
      backgroundColor: 'transparent',
      backgroundClip: 'padding-box',
      transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
      margin: 'inherit',
      marginLeft: 1,
      marginTop: 1,

      //   border: '2px inset',
    },
  },

  suggestions: {
    zIndex: 500,
    minWidth: 400,

    list: {
      backgroundColor: 'var(--select-background-color)',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#556ee6',
        color: 'white',
      },
    },
  },
};
